/* ===========================================================================
   Galerie produit Dazzuro — changement de photo par couleur + slider

   Le theme gere normalement le switch couleur dans MediaGallery, mais il
   s appuie sur slider-element.items, qui vaut Array.from(this.children) :
   uniquement les enfants DIRECTS. Notre mise en page a trois zones imbriquees,
   cette hypothese ne tient plus. On reimplemente donc la regle, a l identique :

     au changement de variante, on lit le media mis en avant (featured_media),
     on releve son data-gang-connect, et on masque tout media dont le
     data-gang-connect differe. Les medias data-gang-default restent visibles.
   =========================================================================== */
(function () {
  function init(racine) {
    if (!racine || racine.dataset.dazgPret) return;
    racine.dataset.dazgPret = '1';

    /* ---------------- changement de couleur ---------------- */
    /* Le vrai formulaire produit porte is="product-form" — c est lui que
       theme.js fait parler. Le formulaire de paiement echelonne le precede
       dans le DOM : le prendre revenait a ecouter un muet. */
    var conteneur = racine.closest('.product');
    var formulaires = conteneur
      ? Array.prototype.slice.call(conteneur.querySelectorAll('form[is="product-form"], form[action*="/cart/add"]'))
      : [];
    var cible = formulaires[0] || document;

    function appliquerVariante(variante) {
      if (!variante || !variante.featured_media) return;
      var reference = racine.querySelector('[data-media-id="' + variante.featured_media.id + '"]');
      if (!reference) return;
      var connect = reference.getAttribute('data-gang-connect');
      if (!connect) return;

      racine.querySelectorAll('[data-gang-connect]').forEach(function (el) {
        el.hidden = el.getAttribute('data-gang-connect') !== connect;
      });
      majSecs();
      majLargeur();
      majFleches();
    }

    /* Mention « Texture Legacy 01 » posee sur la video (voir
       snippets/dazzuro-gallery.liquid) : masquee quand la variante choisie est
       justement le coloris filme. Meme regle de handle que Shopify, et
       comparaison sur la FIN, le mot de couleur devant le nom etant libre. */
    function handle(s) {
      return String(s || '').replace(/Ø/g, 'O').replace(/ø/g, 'o').normalize('NFD').replace(/[\u0300-\u036f\u200b-\u200f\ufeff]/g, '')
        .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }

    function majTextureVideo(variante) {
      var etiquette = racine.querySelector('[data-daz-video-texture]');
      if (!etiquette || !variante) return;
      var cle = etiquette.getAttribute('data-daz-video-texture');
      var options = variante.options || [variante.option1, variante.option2, variante.option3];
      var filme = options.some(function (o) {
        var h = handle(o);
        return h && (h === cle || h.slice(-(cle.length + 1)) === '-' + cle);
      });
      etiquette.hidden = filme;
    }


    /* Coloris filme ABSENT des variantes de la fiche (Marta est filme en
       Raptor 25) : le Liquid n a que le handle et ecrirait « Taupe Fonce ».
       On reprend alors couleur et nom tels que la bibliotheque les ecrit. */
    function nommerTextureVideo() {
      var etiquette = racine.querySelector('[data-daz-video-texture]');
      if (!etiquette || etiquette.hasAttribute('data-daz-video-texture-exact') || !window.TEXTURES) return false;
      var cle = etiquette.getAttribute('data-daz-video-texture');
      var nom = etiquette.querySelector('.dazg__video-texture-nom');
      return window.TEXTURES.some(function (g) {
        return (g.items || []).some(function (it) {
          var complet = [it.color, it.name].filter(Boolean).join(' ');
          if (handle(complet) !== cle) return false;
          if (nom) nom.textContent = complet;
          etiquette.setAttribute('data-daz-video-texture-exact', '');
          return true;
        });
      });
    }
    if (!nommerTextureVideo()) window.addEventListener('load', nommerTextureVideo);

    function surVariante(e) {
      if (e && e.detail && e.detail.variant) {
        majTextureVideo(e.detail.variant);
        appliquerVariante(e.detail.variant);
      }
    }

    /* On ecoute TOUS les formulaires du produit : l evenement est emis sans
       bubbles, donc il faut etre sur le bon element, pas sur un ancetre. */
    formulaires.forEach(function (f) { f.addEventListener('variant:change', surVariante); });
    document.addEventListener('variant:change', surVariante);

    /* Filet supplementaire : le thème publie aussi la variante sur son bus
       interne, qui lui ne depend d aucun element du DOM. */
    if (window.theme && theme.pubsub && theme.pubsub.subscribe) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (evt) {
        if (evt && evt.data && evt.data.variant) {
          majTextureVideo(evt.data.variant);
          appliquerVariante(evt.data.variant);
        }
      });
    }

    /* ---------------- zoom (lightbox) ----------------
       Le theme ouvre PhotoSwipe depuis <media-gallery>, element que notre
       galerie n utilise plus. On instancie donc notre propre lightbox, avec
       la meme configuration et la meme forme de dataSource que le theme.
       PhotoSwipeLightbox est un global fourni par vendor.js. */
    function itemsVisibles() {
      return Array.prototype.filter.call(
        racine.querySelectorAll(".dazg__item"),
        function (el) {
          return !el.hidden
              && !el.classList.contains("dazg__item--evince")
              && el.querySelector("img");
        }
      );
    }

    /** La librairie, quel que soit l endroit ou l UMD l a posee. */
    function lightboxDispo() {
      if (typeof PhotoSwipeLightbox !== "undefined") return PhotoSwipeLightbox;
      if (typeof window !== "undefined" && window.PhotoSwipeLightbox) return window.PhotoSwipeLightbox;
      if (typeof globalThis !== "undefined" && globalThis.PhotoSwipeLightbox) return globalThis.PhotoSwipeLightbox;
      return null;
    }

    /* Chargement du module PhotoSwipe.

       Shopify minifie les assets JS du theme avec esbuild au moment de les
       servir. Un import() dont le specificateur est une VARIABLE n est pas
       statiquement resoluble : esbuild le prend pour du CommonJS et le reecrit
       en require(), qui n existe pas dans un navigateur. Le zoom mourait la,
       sur un "require is not defined", sans meme une requete vers le module.

       Le corps d un new Function n est pas analyse par le bundler : l import()
       ecrit ici arrive intact dans le navigateur. Construit une seule fois. */
    var importerModule = new Function('u', 'return import(u);');

    /** import() n accepte pas partout une URL protocol-relative. */
    function resoudrePswp() {
      var u = (window.theme && window.theme.settings && window.theme.settings.pswpModule) || '';
      if (!u) return null;
      if (u.indexOf('//') === 0) return window.location.protocol + u;
      return u;
    }

    function ouvrirZoom(depuis) {
      var Lightbox = lightboxDispo();
      if (!Lightbox) { console.warn('[galerie] PhotoSwipe indisponible : zoom ignore'); return; }
      var moduleUrl = resoudrePswp();
      if (!moduleUrl) { console.warn('[galerie] chemin du module PhotoSwipe introuvable'); return; }
      var items = itemsVisibles();
      var index = items.indexOf(depuis);
      if (index < 0) index = 0;

      var data = items.map(function (el) {
        var img = el.querySelector("img");
        return {
          thumbnailElement: img,
          src: img.src,
          srcset: img.srcset,
          msrc: img.currentSrc || img.src,
          width: parseInt(img.getAttribute("width"), 10) || img.naturalWidth,
          height: parseInt(img.getAttribute("height"), 10) || img.naturalHeight,
          alt: img.alt,
          thumbCropped: true
        };
      });

      var fleche = '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="M17.5 7.5L10 15L17.5 22.5"/></svg>';
      /* dataSource ne se passe PAS ici : PhotoSwipeLightbox l ignore. Il part
         en second argument de loadAndOpen, comme le fait le theme. */
      var lb = new Lightbox({
        arrowPrevSVG: fleche,
        arrowNextSVG: fleche,
        closeSVG: '<svg class="pswp__icn icon" stroke="currentColor" fill="none" viewBox="0 0 30 30"><path d="m7.5 22.5 15-15m-15 0 15 15"/></svg>',
        bgOpacity: 1,
        pswpModule: function () { return importerModule(moduleUrl); },
        allowPanToNext: false,
        allowMouseDrag: true,
        wheelToZoom: false,
        returnFocus: true,
        zoom: false
      });
      lb.addFilter("thumbEl", function (_el, d) { return d.thumbnailElement; });
      // Une instance est creee a chaque ouverture (le dataSource depend de la
      // variante affichee). On la detruit a la fermeture pour ne pas accumuler
      // d ecouteurs. Le setTimeout laisse PhotoSwipe finir son animation.
      lb.on("close", function () { setTimeout(function () { lb.destroy(); }, 400); });
      try {
        lb.init();
        lb.loadAndOpen(index, data);
      } catch (err) {
        console.error('[galerie] ouverture du zoom impossible :', err);
      }
    }

    racine.addEventListener("click", function (e) {
      var b = e.target.closest ? e.target.closest("[data-dazg-zoom]") : null;
      if (!b) return;
      e.preventDefault();
      ouvrirZoom(b.closest(".dazg__item"));
    });

    /* ---------------- secondaires ----------------
       Mise en lignes des medias de role sec. Aucun numero n intervient :
       l ordre est celui des medias du produit.

       Selon le nombre VISIBLE (donc selon la couleur choisie) :
         1        -> pleine largeur, au format natif de la photo
         2        -> une ligne de 2
         3        -> une ligne de 3
         4 et +   -> une ligne de 2, puis la suite en lignes de 3 et de 2

       Pour la suite, des lignes de 3, et la ligne de 2 inseree en DEUXIEME
       rang. Quand il resterait 1 photo seule, une ligne de 3 est defaite pour
       donner DEUX lignes de 2 : jamais d orpheline en bout de grille.

         4 -> 2+2      7 -> 2+3+2      10 -> 2+3+2+3
         5 -> 2+3      8 -> 2+3+3      11 -> 2+3+3+3
         6 -> 2+2+2    9 -> 2+3+2+2    12 -> 2+3+2+2+3

       Le compte ne peut pas se faire en Liquid : toutes les couleurs sont
       dans le DOM, seules celles de la variante active sont visibles. */
    var zoneSecs = racine.querySelector('[data-dazg-secs]');

    function lignes(n) {
      if (n <= 0) return [];
      if (n <= 3) return [n];
      var k = Math.floor(n / 3);
      var reste = n % 3;
      var out = [];
      for (var i = 0; i < k; i++) out.push(3);
      if (reste === 2) {
        out.splice(1, 0, 2);
      } else if (reste === 1) {
        out.pop();              // une ligne de 3 defaite...
        out.splice(1, 0, 2, 2); // ...en deux lignes de 2
      }
      return out;
    }

    function majSecs() {
      if (!zoneSecs) return;

      /* Video de COLORIS (media du produit, role sec, marque a une couleur) :
         quand le coloris choisi en a une, elle remplace la video du metachamp,
         qui filme un autre habillage. Le metachamp porte data-gang-default,
         que le changement de variante ne touche jamais : c est donc ici qu on
         le masque ou le rend, a chaque passage. */
      var videosCouleur = zoneSecs.querySelectorAll('.dazg__item--video[data-gang-connect]');
      var videoDefaut = zoneSecs.querySelector('.dazg__item--video[data-gang-default]');
      if (videoDefaut) {
        videoDefaut.hidden = Array.prototype.some.call(videosCouleur, function (el) { return !el.hidden; });
      }
      /* Une video masquee ne doit ni tourner ni telecharger pour rien. */
      zoneSecs.querySelectorAll('.dazg__item--video video').forEach(function (v) {
        var cache = v.closest('.dazg__item').hidden;
        if (cache) { v.pause(); } else if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });

      var visibles = Array.prototype.filter.call(
        zoneSecs.querySelectorAll('.dazg__item'),
        function (el) { return !el.hidden; }
      );

      /* La video est ecrite en dernier dans le DOM mais doit tenir la
         deuxieme place. On ne deplace pas le noeud : flex order suffit. */
      var video = null;
      var autres = [];
      visibles.forEach(function (el) {
        if (el.classList.contains('dazg__item--video') && !video) video = el;
        else autres.push(el);
      });
      var ordre = autres.slice();
      if (video) ordre.splice(ordre.length ? 1 : 0, 0, video);

      var n = ordre.length;
      var plan;
      if (n <= 3) {
        plan = [n];                       // 1 seul, 2 de front, ou 3 de front
      } else {
        plan = [2].concat(lignes(n - 2)); // une ligne de 2, puis la suite
      }

      var i = 0;
      plan.forEach(function (taille) {
        for (var k = 0; k < taille; k++) {
          var item = ordre[i];
          if (!item) return;
          item.style.order = i;
          item.setAttribute('data-dazg-col', String(taille));

          /* Le sizes doit suivre la largeur reelle, sinon il ment au
             navigateur : Liquid ne peut en poser qu un pour toute la zone. */
          var img = item.querySelector('img');
          if (img) {
            img.setAttribute('sizes', taille === 3
              ? '(max-width: 767px) 100vw, 22vw'
              : (taille === 1 ? '(max-width: 767px) 100vw, 66vw'
                              : '(max-width: 767px) 100vw, 33vw'));
          }
          i++;
        }
      });
    }

    majSecs();

    /* ---------------- slider ---------------- */
    var piste = racine.querySelector('[data-dazg-track]');
    var prev = racine.querySelector('[data-dazg-prev]');
    var next = racine.querySelector('[data-dazg-next]');
    if (!piste) return;

    function pas() {
      var visible = piste.querySelector('.dazg__item:not([hidden])');
      if (!visible) return piste.clientWidth * 0.28;
      var style = getComputedStyle(piste);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return visible.getBoundingClientRect().width + gap;
    }

    /* Largeur des vignettes.
       Le slider en montre 3,5 : la demi coupee annonce qu il reste a voir.
       Quand la variante courante n expose que trois medias ou moins, cette
       demi-largeur ne montre plus rien et laisse une bande blanche a droite.
       On marque alors la piste du nombre de vignettes visibles ; le CSS leur
       rend la largeur entiere (voir dazzuro-gallery.css, 100/n).

       Le compte ne peut pas se faire en Liquid : tous les medias de toutes
       les couleurs sont dans le DOM, seuls ceux de la variante sont visibles.
       Il est donc refait a chaque changement de couleur. */
    /* Vignette solitaire evincee.

       Le slider ne montre que ce qui n a pas trouve place ailleurs. Quand la
       couleur courante dispose de secondaires, ce sont eux qui portent la
       galerie : garder en plus une unique vignette sans role, etalee sur
       toute la largeur, faisait doublon juste sous la banniere prez.
       Sans aucun secondaire en revanche elle reste — c est alors la seule
       photo disponible apres la prez, et elle merite la pleine largeur.

       L eviction passe par une CLASSE, pas par l attribut hidden : celui-ci
       appartient a la regle de couleur, qui le recalcule sur tous les medias
       a chaque changement de variante. Deux mecanismes sur le meme attribut
       se seraient marche dessus. */
    function evincerSoloSiSecs() {
      var slides = Array.prototype.slice.call(
        piste.querySelectorAll('.dazg__item--slide')
      );
      slides.forEach(function (el) { el.classList.remove('dazg__item--evince'); });

      var visibles = slides.filter(function (el) { return !el.hidden; });
      if (visibles.length !== 1 || !zoneSecs) return;
      if (zoneSecs.querySelectorAll('.dazg__item:not([hidden])').length === 0) return;
      visibles[0].classList.add('dazg__item--evince');
    }

    function majLargeur() {
      if (!piste) return;
      evincerSoloSiSecs();
      var visibles = piste.querySelectorAll(
        '.dazg__item--slide:not([hidden]):not(.dazg__item--evince)');
      var n = visibles.length;
      if (n >= 1 && n <= 3) piste.setAttribute('data-dazg-visibles', String(n));
      else piste.removeAttribute('data-dazg-visibles');

      /* Piste vide : le bloc entier se retire, sinon il laisse le gap de 4px
         de .dazg et la barre de fleches collee sous la prez. */
      var slider = racine.querySelector('.dazg__slider');
      if (slider) slider.hidden = (n === 0);

      /* Le sizes pose par Liquid decrit la vignette de 28vw du slider a 3,5.
         Quand il n en reste qu une, le CSS lui donne toute la largeur de la
         colonne — environ 66vw. Sans correction le navigateur choisirait une
         image deux fois trop petite et l etirerait. */
      Array.prototype.forEach.call(visibles, function (el) {
        var img = el.querySelector('img');
        if (!img) return;
        img.setAttribute('sizes', n === 1
          ? '(max-width: 767px) 100vw, 66vw'
          : '(max-width: 767px) 60vw, 28vw');
      });
    }

    function majFleches() {
      /* En mode grille il n y a pas de piste. appliquerVariante appelle cette
         fonction a chaque changement de couleur : sans cette garde, elle
         dereferencait null et le changement de couleur cassait net. */
      if (!piste) return;
      // marge de 2px : les navigateurs arrondissent scrollLeft
      var debut = piste.scrollLeft <= 2;
      var fin = piste.scrollLeft + piste.clientWidth >= piste.scrollWidth - 2;
      var rien = piste.scrollWidth <= piste.clientWidth + 2;
      if (prev) prev.disabled = debut || rien;
      if (next) next.disabled = fin || rien;
      racine.classList.toggle('dazg--sans-defilement', rien);
    }

    if (prev) prev.addEventListener('click', function () { piste.scrollBy({ left: -pas(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { piste.scrollBy({ left: pas(), behavior: 'smooth' }); });

    piste.addEventListener('scroll', function () {
      window.requestAnimationFrame(majFleches);
    }, { passive: true });

    window.addEventListener('resize', function () {
      window.requestAnimationFrame(majFleches);
    }, { passive: true });

    majLargeur();
    majFleches();
    // les images arrivent apres : on recalcule une fois tout charge
    window.addEventListener('load', majFleches);
  }

  function demarrer() {
    document.querySelectorAll('[data-dazg]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();

  // l editeur de theme re-rend la section
  document.addEventListener('shopify:section:load', demarrer);
})();
